const VEHICLES = {
    TITLE_SECTION_DEFAULT: "Veículos",
    TITLE_DASHBOARD: "Lista de Resultados",
  };
export default VEHICLES;